<template>
  <div class="content">
    <div class="row">
      <div class="col-12">
        <card class="card-plain">
          <!-- <template slot="header">
            <h4 class="card-title">Table on Plain Background</h4>
            <p class="category">Here is a subtitle for this table</p>
          </template>-->
          <div class="table-full-width text-left">
            <fieldType-table
            v-if="fieldTypes && fieldTypes.length > 0"
				:title="table1.title"
				:sub-title="table1.subTitle"
				:fieldTypes="fieldTypes"
				:totalElements="totalElements"
				:page="page"
				:columns="table1.columns"
 				@get-all-field-types="getAllFieldTypes"
             >

            </fieldType-table>
          </div>
        </card>
      </div>

    </div>
  </div>
</template>
<script>
import { Card } from "@/components/Card";

import FieldTypeTable from "@/components/FieldTypeTable";
import FieldTypeService from "../services/FieldTypeService";

const tableColumns = [];
const tableData = [
];

export default {
  components: {
    Card,
    FieldTypeTable,
  },
  data() {
    return {
      fieldTypes: [],
	  totalElements: 0,
      page: 0,
      searchQuery: '',     
      table1: {
        title: "Simple Table",
        columns: [...tableColumns],
        data: [...tableData],
      },
    };
  },
  methods: {
    async getAllFieldTypes(sortBy='fieldTypeId',sortOrder='true',page="0",size="50") {
      try {
        try {
			const searchDTO = {
				sortBy: sortBy, 
				sortOrder: sortOrder, 
				searchQuery: this.searchQuery,
				page: page, 
				size: size
			};
	        let response = await FieldTypeService.getAllFieldTypes(searchDTO);
	        if (!response.data.empty) {
		        if (response.data.fieldTypes.length) {
					this.fieldTypes = response.data.fieldTypes;
				}
      			this.totalElements = response.data.totalElements;
      			this.page = response.data.page;
	        }
        } catch (error) {
          console.error("Error fetching fieldTypes:", error);
        }
        
      } catch (error) {
        console.error("Error fetching fieldType details:", error);
      }
    },
  },
  mounted() {
    this.getAllFieldTypes();
  },
  created() {
    this.$root.$on('searchQueryForFieldTypesChanged', (searchQuery) => {
    	this.searchQuery = searchQuery;
    	this.getAllFieldTypes();
    })
  }
};
</script>
<style></style>
